import { Box, Typography } from '@mui/material';
import SelectComponent from '../components/Select';
import FileUploadDropZone from './FileUploadDropZone';
import Styles from '../theme/commonCss/Styles';

type GatewayOption = {
  value: string;
  label: string;
};

type ImportAssetsModalProps = {
  selectedGatewayId: string;
  gatewayOptions: GatewayOption[];
  onGatewayChange: (gatewayId: string) => void;
  onFileChange: (file: File | null) => void;
  gatewayLabel?: string;
  required?: boolean;
  gatewayPlaceholder?: string;
  disableGatewaySelect?: boolean;
  fileHintText?: string;
  accept?: string;
};

const ImportAssetsModal = ({
  selectedGatewayId,
  gatewayOptions,
  onGatewayChange,
  onFileChange,
  gatewayLabel = 'Select Gateway',
  required = true,
  gatewayPlaceholder,
  disableGatewaySelect = false,
  fileHintText = '(Import Excel / CSV file)',
  accept = '.xlsx,.xls,.csv',
}: ImportAssetsModalProps) => {
  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
        <Typography
          sx={{
            ...Styles.inputLabel,
            width: '126px',
            marginRight: '16px',
            textAlign: 'right',
            flexShrink: 0,
          }}
          className={required ? 'required-field' : ''}
        >
          {gatewayLabel}
        </Typography>
        <SelectComponent
          value={selectedGatewayId ?? ''}
          options={gatewayOptions}
          onChange={(e: any) => onGatewayChange(String(e.target.value ?? ''))}
          placeholder={gatewayPlaceholder || (gatewayOptions.length === 0 ? 'No provisioned gateways' : 'Select')}
          disabled={gatewayOptions.length === 0 || disableGatewaySelect}
        />
      </Box>

      <FileUploadDropZone
        accept={accept}
        helperText={fileHintText}
        onFileSelect={onFileChange}
      />
    </>
  );
};

export default ImportAssetsModal;